import { useEffect, useState } from "react";
import { EndPoints } from "../../../Constants/endpoints";
import { useAppMediaQuery, useGetData } from "../../../hooks";
import { IMedicalRecordItem } from "../../../interface/MedicalRecord";
import RecordCardItem, {
  RecordCardType,
} from "../component/RecordCardItem/RecordCardItem";

import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import EmptyImage from "../../../assets/images/icons/logoOfNoResult.svg";
import MedicalRecordHeader from "../MedicalRecordHeader/MedicalRecordHeader";
import { GeneralButton, InfiniteScroll } from "../../../components";

const PatientMedicalRecords = () => {
  const { id: PatientId } = useParams();
  const { isMobileOrTablet } = useAppMediaQuery();
  const [recordData, setRecordData] = useState<any[]>();
  const outletContext = useOutletContext<any>();

  const { data, isLoading, isSuccess } = useGetData<IMedicalRecordItem[]>(
    EndPoints.GetAllPatientMedicalRecords,
    {
      filter: { PatientId: `${PatientId}` },
      enabled: !!PatientId,
    },
  );
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      outletContext?.setMedicalRecordId &&
        outletContext?.setMedicalRecordId(data?.Data?.[0]?.Id);
    }
  }, [isSuccess]);

  return isLoading ? (
    <>
      <div className="mb-2 h-20 w-full animate-pulse rounded-md bg-gray-200" />
      <div className="mb-2 h-24 w-full animate-pulse rounded-md bg-gray-200" />
    </>
  ) : (
    <>
      {isMobileOrTablet && (
        <div className="flex justify-between py-4 max-md:flex-wrap">
          <MedicalRecordHeader title={t("view_medical_report")} />
          {(recordData?.length ?? 0) > 0 && (
            <GeneralButton
              className="!px-4"
              onClick={() =>
                navigate(`/patient/${PatientId}/add-medical-record`)
              }
              title={t("new_medical_report")}
            />
          )}
        </div>
      )}
      <div className="flex h-3/4 lg:max-h-[77vh] flex-col gap-2 overflow-auto">
        {recordData?.map((item, index) => {
          return (
            <RecordCardItem
              item={item}
              key={index}
              type={RecordCardType.MedicalReport}
            />
          );
        })}
        <InfiniteScroll
          Count={16}
          skeletonCount={12}
          endpoint={EndPoints.GetAllPatientMedicalRecords}
          getAllParams={{
            PatientId: PatientId,
          }}
          getData={(data) => setRecordData(data)}
          renderSkeleton={
            <>
              <div className="mb-2 h-20 w-full animate-pulse rounded-md bg-gray-200" />
              <div className="mb-2 h-24 w-full animate-pulse rounded-md bg-gray-200" />
            </>
          }
          noDataElement={
            <div className="flex flex-col items-center justify-center gap-4 text-center text-lg">
              <img src={EmptyImage} alt="Empty" className="mx-auto h-16 w-16" />
              <p>{t("there_are_no_medical_record_for_this_patient_yet")}</p>
            </div>
          }
        />
      </div>
    </>
  );
};

export default PatientMedicalRecords;
